import { fireLinkTag } from './tagManager';
/**
 * @param {boolean} isOpen
 */
function tagViewMoreViewLessToggle(isOpen) {
  const eventName = isOpen
    ? 'product details view more'
    : 'product details view less';

  fireLinkTag({ event_name: eventName, link_name: eventName });
}

export default tagViewMoreViewLessToggle;
